<button
  size="small"
  p-button
  class="ml-3 split-button-orange-1"
  [class.active]="hasValue"
  type="button"
  (click)="showOverlayPanel($event)">
  {{ displayLabel }}
</button>

<p-overlayPanel #op (onHide)="hideOverlayPanel()" appendTo="body" [style]="{'min-width': '340px'}">
  <div *ngIf="isActiveOverlay" class="split-filter-date-panel">

    <div class="flex justify-content-center mb-3">
      <p-selectButton
        [options]="modeOptions"
        [(ngModel)]="mode"
        (ngModelChange)="onModeChange()"
        optionLabel="label"
        optionValue="value">
      </p-selectButton>
    </div>

    <ng-container *ngIf="mode === 'range'">
      <p-calendar
        [(ngModel)]="rangeValue"
        selectionMode="range"
        [inline]="true"
        [style]="{'width': '300px'}"
        (click)="$event.stopPropagation()">
      </p-calendar>
    </ng-container>

    <ng-container *ngIf="mode === 'month'">
      <p-calendar
        [(ngModel)]="monthValue"
        view="month"
        [inline]="true"
        [style]="{'width': '300px'}"
        (click)="$event.stopPropagation()">
      </p-calendar>
    </ng-container>

    <div class="flex justify-content-between mt-3">
      <p-button
        (click)="onCancel()"
        label="Cancelar"
        [outlined]="true"
        severity="secondary">
      </p-button>
      <p-button
        [disabled]="!hasValue"
        (click)="onApply()"
        label="Aplicar">
      </p-button>
    </div>

  </div>
</p-overlayPanel>
